import { render, staticRenderFns } from "./CollectionsModuleLayout.vue?vue&type=template&id=506c4340"
import script from "./CollectionsModuleLayout.vue?vue&type=script&lang=js"
export * from "./CollectionsModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports